"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.replace");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getCurrentLanguage = getCurrentLanguage;
exports.removeLanguageChangeHandler = removeLanguageChangeHandler;
exports.onLanguageChange = onLanguageChange;
exports.changeLanguage = changeLanguage;
exports.addKey = addKey;
exports.addKeys = addKeys;
exports.loadKeys = loadKeys;
exports.translate = translate;
exports.translateHTML = translateHTML;
exports.instantTranslate = instantTranslate;
exports.instantTranslateHTML = instantTranslateHTML;
exports.getLanguageListAsync = getLanguageListAsync;
exports.interceptor = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

require("regenerator-runtime/runtime");

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createForOfIteratorHelper"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));

var _map2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/map"));

var _language = require("../environment/language");

var _utils = require("../utils");

var _environment = require("../environment");

var _interpolation = require("./interpolation");

var _html = require("./html");

var _interceptor = _interopRequireWildcard(require("./interceptor"));

var _ref, _getFromCookie;

var getFromCookie = function getFromCookie() {
  return (0, _utils.cookie)('BMLanguageCode');
};

var setToCookie = function setToCookie(lang) {
  return (0, _utils.cookie)('BMLanguageCode', lang, '/', true);
};

var interceptor = _interceptor;
exports.interceptor = interceptor;
var currentLanguage = (_ref = (_getFromCookie = getFromCookie()) !== null && _getFromCookie !== void 0 ? _getFromCookie : (0, _language.getCountryDefaultLanguage)()) !== null && _ref !== void 0 ? _ref : 'en-US';
var store = new _map2.default();
store.set(currentLanguage, new _map2.default());
var currentStore = store.get(currentLanguage);

function ensureLanguageStore(langCode) {
  var _store$get;

  currentStore = (_store$get = store.get(langCode)) !== null && _store$get !== void 0 ? _store$get : new _map2.default();
  store.set(langCode, currentStore);
  return currentStore;
}

function getCurrentLanguage() {
  var withOutDash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (withOutDash) {
    return currentLanguage.replace('-', '');
  }

  return currentLanguage;
}

var handlers = [];

function removeLanguageChangeHandler(fn) {
  (0, _splice.default)(handlers).call(handlers, (0, _indexOf.default)(handlers).call(handlers, fn), 1);
}

function onLanguageChange(fn) {
  handlers.push(fn);
  return function () {
    return removeLanguageChangeHandler(fn);
  };
}

function normalizeLanguageCode(langCode) {
  var _context;

  return (0, _concat.default)(_context = "".concat((0, _slice.default)(langCode).call(langCode, 0, 2).toLowerCase(), "-")).call(_context, (0, _slice.default)(langCode).call(langCode, langCode.length - 2).toUpperCase());
}

function changeLanguage(langCode) {
  var newLanguageCode = normalizeLanguageCode(langCode);

  if (newLanguageCode === currentLanguage) {
    return;
  }

  currentStore = ensureLanguageStore(newLanguageCode);
  currentLanguage = newLanguageCode;
  setToCookie(currentLanguage);
  (0, _map.default)(handlers).call(handlers, function (fn) {
    return fn();
  });
}

function addKey(key, translation, langCode) {
  var _langCode;

  langCode = (_langCode = langCode) !== null && _langCode !== void 0 ? _langCode : currentLanguage;
  var store = ensureLanguageStore(langCode);
  store.set(key, translation);
}

function addKeys(obj, langCode) {
  for (var _key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, _key)) {
      addKey(_key, obj[_key], langCode);
    }
  }
}

function loadKeys(_x, _x2) {
  return _loadKeys.apply(this, arguments);
}

function _loadKeys() {
  _loadKeys = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url, langCode) {
    var response;
    return _regenerator.default.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(url);

          case 2:
            response = _context2.sent;
            _context2.t0 = addKeys;
            _context2.next = 6;
            return response.json();

          case 6:
            _context2.t1 = _context2.sent;
            _context2.t2 = langCode;
            return _context2.abrupt("return", (0, _context2.t0)(_context2.t1, _context2.t2));

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee);
  }));
  return _loadKeys.apply(this, arguments);
}

function translate(_x3, _x4, _x5) {
  return _translate.apply(this, arguments);
}

function _translate() {
  _translate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(key, interpolation, langCode) {
    var _langCode3, _ref3, _store$get3;

    var enUSStore, store;
    return _regenerator.default.wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            langCode = (_langCode3 = langCode) !== null && _langCode3 !== void 0 ? _langCode3 : currentLanguage;
            enUSStore = ensureLanguageStore('en-US');
            store = ensureLanguageStore(langCode);
            return _context3.abrupt("return", _promise.default.resolve((0, _interpolation.interpolate)((_ref3 = (_store$get3 = store.get(key)) !== null && _store$get3 !== void 0 ? _store$get3 : enUSStore.get(key)) !== null && _ref3 !== void 0 ? _ref3 : key, interpolation !== null && interpolation !== void 0 ? interpolation : {})));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2);
  }));
  return _translate.apply(this, arguments);
}

function translateHTML(_x6, _x7, _x8) {
  return _translateHTML.apply(this, arguments);
}

function _translateHTML() {
  _translateHTML = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(key, interpolation, langCode) {
    return _regenerator.default.wrap(function _callee3$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", translate(key, interpolation, langCode).then(function (translated) {
              return (0, _html.parseHTML)(translated);
            }));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee3);
  }));
  return _translateHTML.apply(this, arguments);
}

function instantTranslate(key, interpolation, langCode) {
  var _langCode2, _ref2, _store$get2;

  langCode = (_langCode2 = langCode) !== null && _langCode2 !== void 0 ? _langCode2 : currentLanguage;
  var enUSStore = ensureLanguageStore('en-US');
  var store = ensureLanguageStore(langCode);
  return (0, _interpolation.interpolate)((_ref2 = (_store$get2 = store.get(key)) !== null && _store$get2 !== void 0 ? _store$get2 : enUSStore.get(key)) !== null && _ref2 !== void 0 ? _ref2 : key, interpolation !== null && interpolation !== void 0 ? interpolation : {});
}

function instantTranslateHTML(key, interpolation, langCode) {
  return (0, _html.parseHTML)(instantTranslate(key, interpolation, langCode));
}

function getLanguageListAsync(_x9) {
  return _getLanguageListAsync.apply(this, arguments);
}

function _getLanguageListAsync() {
  _getLanguageListAsync = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(includeCurrentLanguage) {
    var languageList;
    return _regenerator.default.wrap(function _callee4$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            languageList = [];
            return _context6.abrupt("return", (0, _environment.getSupportedLanguagesAsync)().then(function (languages) {
              var _context5;

              if (!languages) {
                return languageList;
              }

              return (0, _map.default)(_context5 = (0, _filter.default)(languages).call(languages, function (lang) {
                return lang.code !== getCurrentLanguage() || includeCurrentLanguage;
              })).call(_context5, function (lang) {
                return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, lang), {}, {
                  translatedDescription: getTranslatedDescription(lang, getCurrentLanguage())
                });
              });
            }));

          case 2:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee4);
  }));
  return _getLanguageListAsync.apply(this, arguments);
}

function getTranslatedDescription(language, translateCode) {
  var description = language.description;

  if (!language.translations) {
    return description;
  }

  var _iterator = (0, _createForOfIteratorHelper2.default)(language.translations),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var translation = _step.value;

      if (translation.code === translateCode) {
        description = translation.description;
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return description;
}
